var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 119",
    width: 136,
    height: 119,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-86-74h1199v1683h-1199z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#8c9391}.b{fill:#a8a7ad}.c{fill:#68bebf}.d{fill:#778fca}.e{fill:#dae2a6}.f{fill:#a1cfb3}.g{fill:#d784b5}.h{fill:#9c90b4}.i{fill:#7084c4}.j{fill:#95a2ac}.k{fill:#eba294}.l{fill:#c9dca6}.m{fill:#b87d93}.n{fill:#9b9799}.o{fill:#5eafdf}.p{fill:#e0d497}.q{fill:#6a9aaf}.r{fill:#9199a2}.s{fill:#768189}.t{fill:#9492cb}.u{fill:#76aed6}.v{fill:#f3bc8a}.w{fill:#e5e18c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m72.1 65.1c0 2.6-2.1 4.6-4.6 4.6-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6 2.5 0 4.6 2.1 4.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m35.7 71.7c-7.5 4.3-11.8 6.3-23.5 1.6 1.1-1.6 11.9-9 23.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m76.5 116c-0.9 3.4-14.6 4.2-16.9 0.7 0-1.6 3.8-29.2 3.8-34.7-0.6-1.6-1.6-10.6-21.7-28.8 3.2 1.1 19.7 13.3 25.8 21.7 3.5-4.6 18.1-19 25.2-22.2-2.5 3-18.5 18.7-19.7 26.8-1.5 11.1 4.6 34.2 3.5 36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m55 72.9c-3.4 7.3-8.9 9.8-20.6 9.8 1.4-3 8.2-12.3 20.6-9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m52.3 67.5c-6 2.1-13.3 4.1-23.4-4 4.1-2.7 17.2-3.9 23.4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m23.4 61.6c-4.4 2.5-14 5.5-23.1-1.3 0.6-1.9 14.2-6.4 23.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m13.5 49.6c6.5 8.5 17.4 8.7 22 6.7-6.6-10-20.3-8.2-22-6.7zm-12.6-15.2c3.6 8.7 15.7 11.2 21.3 10.5-6.4-12-16.9-10.6-21.3-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m30.5 33.1c-5.6 0.6-17.8-1.9-21.4-10.6 4.4-0.1 15-1.4 21.4 10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m45 49.6c-3.3 0-14.5 0.7-20-11.7 2.1-1 17.4 0.2 20 11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m46.9 38.7c-6.3 0.2-14.8-3.2-16.4-14.4 2-0.6 14.9 2.1 16.4 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m47.3 26.3c-6.4-2-14.7-6.6-13.6-17.8 5.7 1.5 11.8 6.2 13.6 17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m57.5 20.8c-4.3-3.6-10.1-8.5-4.2-20.7 1.7 2.4 10.8 8.3 4.2 20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "l",
    d: "m58.7 42.8c-2-1.6-10.5-5.2-6.2-19.7 1.9 1.3 12.2 8.8 6.2 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m63.4 58.9c-3.6 0-15.8-4.6-15.1-15.1 1.6-0.5 12.2 1.1 15.1 15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m67.5 32.9c-2.6-2.6-8.7-11.5-0.7-20.9 1.4 2.3 9.8 7.8 0.7 20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "m",
    d: "m68 57.7c-2.8-3.8-8.5-10.2-1.2-21.4 2.4 2.5 9.6 8.6 1.2 21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m76.5 21.3c-1.9-4-5.8-11.3 4.5-20.9 1.6 3.1 6.3 12-4.5 20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m82.9 23c-9.6 4.9-9 15.3-7.8 18.8 11.7-6.6 9.2-16.3 7.8-18.8zm21.2-0.6c-9.8 1.3-14.6 9.3-14.9 15.9 13.1-3.9 15.1-11.1 14.9-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "o",
    d: "m88.9 25.2c0-4 2.5-15.7 13.1-17.6 0.2 2.9 2.5 11.5-13.1 17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "p",
    d: "m107.4 32c0.4-3.7 1.8-11.1 15.9-14.5 0 2.4 0.3 12.2-15.9 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "q",
    d: "m113.9 43.6c1.4-4.1 7.3-11.2 20.4-10.1-0.3 3.3-3.4 10.1-20.4 10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "r",
    d: "m90.9 49.5c3.2-5 6.1-12.3 18.7-12.1-2.1 4.6-1.4 8.7-18.7 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s",
    d: "m73.3 58.4c2-6.8 0.9-11.8 14.8-15.7 0.9 2.7-0.6 12.8-14.8 15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "t",
    d: "m99.5 55.3c5.8-4.7 8.3-8.9 22.5-6.9-2.8 4.3-6.4 10-22.5 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m112.6 61.2c10-5 17.6-6.4 23.3-1.1-4.3 2.7-11.5 7-23.3 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m100 70.5c6.9-2.5 15.6-5.4 22.9 0.9-1.4 2.4-12.4 7.1-22.9-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "v",
    d: "m105.9 62.3c-4 3.9-7.2 9.2-22.8 4.8 3.7-2.5 12.1-10.3 22.8-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m81.5 72.9c3.8 7.1 13 11 20.4 9.1-6.8-12.5-18-9.6-20.4-9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0dda499abcb9fb76d012e193b6dd643b.svg";
export { ForwardRef as ReactComponent };